module.exports = __webpack_public_path__ + "img/(6).15061d00.jpg";